<div class="dialog-form">
    <form (submit)="formValidations() && save()" [formGroup]="userForm">

        <div class="form-group">
            <div class="form-control">
                <label>Id</label>
                <input pInputText type="text" formControlName="id" readonly name="id">
            </div>
            <div class="form-control">
                <label for="username">{{ 'USERNAME' | translate }}*</label>
                <input pInputText type="text" formControlName="username" [readonly]="model.id" (blur)="usernameInUse()"
                    name="username" autocomplete="off">
            </div>
            <div class="form-control" *ngIf="!model?.id || userForm.get('changePassword').value">
                <label for="password">{{ 'PASSWORD' | translate }}*</label>
                <input pInputText type="password" formControlName="password" name="password" maxlength="50">
            </div>
            <div class="form-control" *ngIf="!model?.id || userForm.get('changePassword').value">
                <label for="confirmPassword">{{ 'CONFIRM-PASSWORD' | translate }}*</label>
                <input pInputText type="password" formControlName="confirmPassword" name="confirmPassword"
                    maxlength="50" (blur)="validPassword()">
            </div>
        </div>
        <br>
        <div class="form-group">
            <div class="form-control">
                <label for="firstName">{{ 'FIRST-NAME' | translate }}*</label>
                <input pInputText type="text" formControlName="firstName" name="firstName" maxlength="50">
            </div>
            <div class="form-control">
                <label for="lastName">{{ 'LAST-NAME' | translate }}*</label>
                <input pInputText type="text" formControlName="lastName" name="lastName" maxlength="50">
            </div>
            <div class="form-control">
                <label for="email">{{ 'EMAIL' | translate }}*</label>
                <input pInputText type="email" formControlName="email" name="email" maxlength="100">
            </div>
            <div class="form-control">
                <label for="bracelet">{{ 'BRACELET' | translate }}</label>
                <input pInputText type="text" formControlName="bracelet" name="bracelet" maxlength="50">
            </div>
        </div>
        <br>
        <div class="form-group">
            <div class="form-control" *ngIf="model.id">
                <label for="changePassword">{{ 'CHANGE-PASSWORD' | translate }}</label>
                <p-inputSwitch formControlName="changePassword" name="changePassword" (onChange)="changePass($event)">
                </p-inputSwitch>
            </div>
            <div class="form-control">
                <label for="active">{{ 'ACTIVE' | translate }}</label>
                <p-inputSwitch formControlName="active" name="active">
                </p-inputSwitch>
            </div>
            <div class="form-control">
                <label for="role">{{ 'Perfil de Usuário' | translate }}</label>
                <p-dropdown placeholder="Selecione..." [filter]="true" [options]="rolesList" appendTo="body"
                    formControlName="roleId" name="roleId" (onChange)="onRoleChange()">
                </p-dropdown>
            </div>
            <!-- EAS-327: substitui o perfil Visualizador e o preset "Visualização" do cadeado.
                 Só aparece com o EAS-327 ligado no backend (sem ele o cadeado da lista continua). -->
            <div class="form-control" *ngIf="viewOnlyAvailable"
                [pTooltip]="isAdminRole ? 'O perfil Administrador não aceita somente visualização.' : 'O usuário continua vendo tudo que o perfil alcança, mas não altera nem exclui registros.'"
                tooltipPosition="top">
                <label for="viewOnly">Somente visualização</label>
                <p-inputSwitch [(ngModel)]="viewOnly" [ngModelOptions]="{ standalone: true }"
                    (onChange)="onViewOnlyChange($event.checked)"
                    [disabled]="viewOnlyDisabled" name="viewOnly" inputId="viewOnly">
                </p-inputSwitch>
                <small class="hint">Passa a valer no próximo acesso do usuário.</small>
            </div>
            <!-- Permissao de token de integracao da API publica (POST /auth/token).
                 O efeito e imediato: a API confere esta permissao em cada requisicao,
                 entao desligar corta os tokens ja emitidos na hora. -->
            <div class="form-control"
                pTooltip="Permite que este usuario gere token de acesso a API publica, para integracao com outros sistemas. Desligar corta na hora os tokens que ele ja gerou."
                tooltipPosition="top">
                <label for="integrationTokenEnabled">Token de integracao</label>
                <p-inputSwitch formControlName="integrationTokenEnabled" name="integrationTokenEnabled"
                    inputId="integrationTokenEnabled">
                </p-inputSwitch>
                <small class="hint">Desligar invalida os tokens ja gerados.</small>
            </div>
        </div>
        <!-- EAS-327: permissão própria (cadeado legado / backfill do EAS-198) ignora o perfil.
             Sem este aviso ela ficaria em vigor sem aparecer em tela nenhuma. -->
        <div class="own-permissions-warning" *ngIf="viewOnlyAvailable && hasOwnPermissions">
            <span>
                <i class="pi pi-exclamation-triangle"></i>
                Este usuário tem <strong>permissões próprias</strong>, configuradas individualmente, que
                <strong>ignoram o perfil</strong> selecionado acima.
            </span>
            <button class="easymarine primary" type="button" (click)="useRolePermissions()">
                Usar as permissões do perfil
            </button>
        </div>
        <br>
        <div class="form-group align-center">
            <div class="form-control">
                {{'REQUIRED-FIELDS' | translate}}
            </div>
            <div class="buttons">
                <button class="easymarine danger" type="button"
                    (click)="dialogRef.close()">{{ 'CANCEL' | translate }}</button>
                <button class="easymarine primary" type="submit">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>